import React, { FC, useState } from 'react';
import { Dropdown, MenuProps, Modal } from 'antd';
import ImgMemberOptions from '@/shared/pictures/member_options.svg';
import { useStore } from '@/app/providers/StoreProvider';
import { IMemberTeam } from '../types';
import ImgClose from '@/shared/pictures/close.svg';
import { glueName } from '@/shared/utils/users';


interface MemberOptionsProps {
  member:IMemberTeam
}

export const MemberOptions:FC<MemberOptionsProps> = ({member}) => {
  const {teamStore} = useStore();
  const {leaveTeam} = teamStore;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleDelete = () => {
    leaveTeam(member.userId);
    setIsModalOpen(false);
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div className='team-members-options_default team-members-options_red' onClick={()=>{setIsModalOpen(true)}}>
          Удалить участника
        </div>

      ),
      key: '0',
    }
  ];
  return (
    <>
    <Dropdown menu={{items}} trigger={['click']}>
      <img className='team-members-options' src={ImgMemberOptions} alt="options" />
    </Dropdown>


    <Modal
        title = {null}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        footer={null}
        closeIcon={<img src={ImgClose} onClick={()=>handleCancel()}/>}
      >
        <div className='modal'>
          <div className='modal_body'>
            <h3 className='modal_title'>Удалить участника?</h3>
            <p className='modal_text'>Участник "{glueName(member)}" будет удален из вашей команды!</p>
          </div>

          <div className='modal_buttons'>
            <button type='button' className='modal_button button_red' onClick={handleDelete}>Удалить</button>
            <button type='button' className='modal_button button_gray' onClick={handleCancel}>Отменить</button>
          </div>
        </div>
      </Modal>

    </>


  );
};
